import { combineReducers } from 'redux';
import { reducer as toastrReducer } from 'react-redux-toastr';

import callRequestReducer from './callRequestReducer';
import callReducer from './callReducer';
import storeReducer from './storeReducer';
import customerReducer from './customerReducer';
import catalogReducer from './catalogReducer';
import cartReducer from './cartReducer';

export default combineReducers({
    callRequest: callRequestReducer,
    call: callReducer,
    stores: storeReducer,
    customer: customerReducer,
    catalog: catalogReducer,
    cart: cartReducer,
    toastr: toastrReducer,
});
